/**
 * "Bỏ qua" một người trong danh sách rà ngược (260922 E1-P2) — nhớ theo TRUYỆN, ở trình duyệt người đang xem.
 *
 * Cố ý không lưu DB: đây là tiện nghi của người vận hành (ẩn thứ luật phân loại đoán sai, vd đồ vật "contract" lọt vào
 * `presence`), không phải dữ liệu phim. Storage có thể hỏng / bị chặn ⇒ mọi lần đọc ghi đều bọc try/catch, hỏng thì coi
 * như chưa bỏ qua gì.
 */
const keyOf = (storyId: string) => `talebox-cast-dismissed:${storyId}`;

export function readDismissed(storyId: string): string[] {
  try {
    const raw = window.localStorage.getItem(keyOf(storyId));
    const v = raw ? JSON.parse(raw) : [];
    return Array.isArray(v) ? v.filter((x) => typeof x === 'string') : [];
  } catch { return []; }
}

export function addDismissed(storyId: string, key: string): string[] {
  const next = Array.from(new Set([...readDismissed(storyId), key]));
  try { window.localStorage.setItem(keyOf(storyId), JSON.stringify(next)); } catch { /* bỏ qua: chỉ là tiện nghi */ }
  return next;
}

export function clearDismissed(storyId: string): void {
  try { window.localStorage.removeItem(keyOf(storyId)); } catch { /* như trên */ }
}
